import React from 'react';
import './DailyTimesheetForm.scss';
import {
    Button,
    Input,
    InputGroup,
    Modal,
    ModalBody,
    ModalFooter,
    ModalHeader,
} from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCancel, faHandPointLeft } from '@fortawesome/free-solid-svg-icons';
import { FormLabel } from '../common/forms/FormElements';

export default class DailyTimesheetRejectButton extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            showModal: false,
            rejectionNotes: '',
        };
    }

    toggleModal = () => {
        const { showModal } = this.state;

        this.setState({ showModal: !showModal });
    };

    initiateRejection = async () => {
        const { onRejectClick } = this.props;
        const { rejectionNotes } = this.state;

        await onRejectClick(rejectionNotes);

        this.setState({ showModal: false, rejectionNotes: '' });
    };

    render() {
        const { saving } = this.props;
        const { showModal, rejectionNotes } = this.state;

        const rejectionNotesInsufficient =
            !rejectionNotes || rejectionNotes.length < 5;

        return (
            <>
                <Button color="danger" type="button" onClick={this.toggleModal}>
                    <FontAwesomeIcon icon={faHandPointLeft} className="mr-2" />
                    Return for Adjustments
                </Button>

                <Modal isOpen={showModal} toggle={this.toggleModal} size="xl">
                    <ModalHeader toggle={this.toggleModal}>
                        Rejecting Timesheet - Notes Needed
                    </ModalHeader>
                    <ModalBody>
                        <div>
                            Please provide some feedback explaining the reason
                            for this timesheet's rejection. Please remember that
                            this will be visible to the employee.
                        </div>

                        <InputGroup>
                            <FormLabel text="Rejection Note" />

                            <Input
                                type="textarea"
                                value={rejectionNotes || ''}
                                onChange={(e) =>
                                    this.setState({
                                        rejectionNotes: e.target.value,
                                    })
                                }
                                maxLength={500}
                                max={500}
                                invalid={rejectionNotesInsufficient}
                                className="ml-2"
                            />
                        </InputGroup>
                    </ModalBody>
                    <ModalFooter>
                        <div className="mr-auto">
                            <Button
                                type="button"
                                color="warning"
                                outline
                                onClick={this.toggleModal}
                                disabled={saving}
                            >
                                <FontAwesomeIcon
                                    icon={faCancel}
                                    className="mr-1"
                                />
                                Cancel
                            </Button>
                        </div>
                        <div>
                            <Button
                                type="button"
                                outline={rejectionNotesInsufficient}
                                disabled={rejectionNotesInsufficient || saving}
                                onClick={this.initiateRejection}
                                color="success"
                            >
                                <FontAwesomeIcon
                                    icon={faHandPointLeft}
                                    className="mr-1"
                                    pulse={saving}
                                />
                                Return To Employee
                            </Button>
                        </div>
                    </ModalFooter>
                </Modal>
            </>
        );
    }
}
